<div class="forgot-password-page">
  <div class="forgot-password-container">
    <!-- Logo -->
    <div class="logo">
      <i class="fa fa-cubes"></i>
    </div>

    <!-- Header -->
    <div class="forgot-password-header">
      <h2>Mot de passe oublié</h2>
      <p>Entrez votre adresse email pour recevoir un lien de réinitialisation</p>
    </div>

    <!-- Success State -->
    <div *ngIf="isEmailSent" class="success-container">
      <div class="success-message">
        <i class="fa fa-check-circle"></i>
        <span>{{ successMessage }}</span>
      </div>
      
      <div class="success-actions">
        <button 
          type="button" 
          class="secondary-button"
          (click)="resendEmail()">
          <i class="fa fa-envelope"></i>
          Envoyer un autre email
        </button>
      </div>
    </div>

    <!-- Error Message -->
    <div class="error-container" *ngIf="errorMessage && !isEmailSent">
      <div class="error-message">
        <i class="fa fa-exclamation-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>
    </div>

    <!-- Forgot Password Form -->
    <form *ngIf="!isEmailSent" (ngSubmit)="onSubmit()" #forgotPasswordForm="ngForm" class="forgot-password-form">
      <div class="form-group">
        <label for="email">Adresse email</label>
        <div class="input-group">
          <i class="fa fa-at"></i>
          <input 
            type="email" 
            id="email"
            [(ngModel)]="email" 
            name="email" 
            placeholder="Entrez votre adresse email"
            autocomplete="email"
            required
            #emailInput="ngModel">
        </div>
        <div class="error-hint" *ngIf="emailInput.invalid && emailInput.touched">
          L'adresse email est requise et doit être valide
        </div>
      </div>

      <button 
        type="submit" 
        class="forgot-password-button" 
        [disabled]="forgotPasswordForm.invalid || isLoading"
        [class.loading]="isLoading">
        <span *ngIf="!isLoading">Envoyer le lien de réinitialisation</span>
        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>
      </button>
    </form>

    <div class="divider">
      <span>ou</span>
    </div>

    <div class="navigation-links">
      <div class="back-to-login">
        <a (click)="goToLogin()" class="back-link">
          Retour à la connexion
        </a>
      </div>
      
      <div class="signup-prompt">
        <a (click)="goToSignup()" class="signup-link">
          Créer un compte
        </a>
      </div>
    </div>
  </div>
</div> 